import { render, staticRenderFns } from "./KurccInspectionsPage.vue?vue&type=template&id=628be57a&"
import script from "./KurccInspectionsPage.vue?vue&type=script&lang=js&"
export * from "./KurccInspectionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports